import React from "react"

const MenuLayout = props => {
  return (
    <div className="food">
      <h5 className="menu-title">{props.title}</h5>
      {props.description ? (
        <p className="items-des">{props.description}</p>
      ) : null}
      {props.children}
    </div>
  )
}

export default MenuLayout
